import { History } from 'history';

export const redirect404 = (history: History) =>
  history.replace({ ...history.location, state: { is404: true } });
